module.exports = __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/play-fff49b519bcd19f0aa40c89a5aad7804.svg";